import { render, staticRenderFns } from "./TariffBen.vue?vue&type=template&id=4ce88f6b&"
import script from "./TariffBen.vue?vue&type=script&lang=js&"
export * from "./TariffBen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports